/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { ICartIconViewProps } from './c-mob-cart-icon';

const CartIconView: React.FC<ICartIconViewProps> = (props: ICartIconViewProps) => (
    <span aria-label='Items in cart' className='Header-MinicartItemCount mobile-MinicartItemCount'>
        {props.data.cart.result?.totalItemsInCart || 0}
    </span>
);

export default CartIconView;
